import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  onBeforeMount, onBeforeUnmount, reactive, ref,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePageLoader',
  setup(__props) {

const pageHeader = ref();
const pageFooter = ref();
const solarLeadFormHeader = ref();
const loaderHeight = reactive({ value: '100vh' });

const calculateLoaderHeight = () => {
  pageHeader.value = document.querySelector('header');
  pageFooter.value = document.querySelector('footer');
  solarLeadFormHeader.value = document.querySelector('#solar-lead-form > .form-header');

  let { innerHeight } = window;

  if (pageHeader.value) {
    innerHeight -= pageHeader.value.offsetHeight;
  }

  if (pageFooter.value) {
    innerHeight -= pageFooter.value.offsetHeight;
  }

  if (solarLeadFormHeader.value) {
    innerHeight -= solarLeadFormHeader.value.offsetHeight;
  }

  loaderHeight.value = `${innerHeight}px`;
};

onBeforeMount(() => {
  window.addEventListener('resize', calculateLoaderHeight);
  calculateLoaderHeight();
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', calculateLoaderHeight);
});

return (_ctx: any,_cache: any) => {
  const _component_BaseLoader = _resolveComponent("BaseLoader")!

  return (_openBlock(), _createElementBlock("div", {
    class: "base-page-loader",
    style: _normalizeStyle({
         '--loader-height': loaderHeight.value,
      })
  }, [
    _createVNode(_component_BaseLoader, { show: "" })
  ], 4))
}
}

})